import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ShellService } from '@mynexus/mfe-core';

@NgModule({ declarations: [],
    exports: [CommonModule], imports: [CommonModule], providers: [
        ShellService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class CoreModule {}
